var Update_SortBy = {
	init:function(){
		
		var _form = document.getElementsByClassName("woocommerce-ordering")[0];
		
		_form.addEventListener("change", function(){
			
		})
		
		$('.woocommerce-ordering').find("select.orderby").on("change", function(){
			$( this ).closest( 'form' ).submit();
		})
	}
}

$(window).load(function(){
	if($('.woocommerce-ordering').length){
		Update_SortBy.init();
	}
})
